import { doc, onSnapshot } from 'firebase/firestore';
import { callPath, type CallDoc } from '@hotel-voice/shared';
import { firestore } from './app';

/**
 * Live call state, straight from Firestore.
 *
 * This is the whole signalling layer for the guest: no polling, no WebSocket,
 * no custom server. The guest is allowed to read exactly this one document
 * (`guestId == uid`, see firestore.rules) and the server is the only writer, so
 * whatever arrives here is authoritative.
 */
export function watchCall(
  hotelId: string,
  callId: string,
  onChange: (call: CallDoc | null) => void,
  onError?: (error: unknown) => void,
): () => void {
  return onSnapshot(
    doc(firestore(), callPath(hotelId, callId)),
    (snapshot) => onChange(snapshot.exists() ? (snapshot.data() as CallDoc) : null),
    (error) => onError?.(error),
  );
}
